<h1 mat-dialog-title>Congratulations!</h1>
<div mat-dialog-content>
  <p>You have successfully registered</p>
  <p>You can now sign-in and modify your organization information. When the SmartEEs administrator validates it's information, it will be public available.</p>
</div>
<div mat-dialog-actions>
  <button mat-button class="default" cdkFocusInitial (click)="dialogRef.close(true)">Ok</button>
</div>
